import request from '@/utils/request'

// 查询消息列表分页
export function pageNotice (query) {
  return request({
    url: '/news/page',
    method: 'get',
    params: query,
  })
}
// 查询消息列表
export function listNotice (query) {
  return request({
    url: '/news/list',
    method: 'get',
    params: query,
  })
}
// 查询消息列表
export function noticeWay (query) {
  return request({
    url: '/news/way/page',
    method: 'get',
    params: query,
  })
}
// 查询消息详细
export function getNotice (query) {
  return request({
    url: '/news/way/detail',
    method: 'get',
    params: query,
  })
}

// 新增消息
export function addNotice (data) {
  return request({
    url: '/news/add',
    method: 'post',
    data: data,
  })
}
// 修改消息
export function updateNotice (data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data,
  })
}
// 已读消息
export function waySave (data) {
  return request({
    url: '/news/way/save',
    method: 'put',
    data: data,
  })
}

// 删除消息
export function delNotice(data) {
  return request({
      url: '/news/delete',
      method: 'post',
      data: data,
  })
}
